import React from "react";
import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";

const TermsOfServicePage = () => {
  const navigate = useNavigate();

  const handleBackClick = () => {
    navigate(-1);
  };

  return (
    <div className="min-h-screen bg-gray-50 font-sans text-gray-800">
      <div className="sticky top-0 z-10 bg-white/80 backdrop-blur-sm border-b border-gray-200 shadow-sm">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-3">
              <img
                src="/QemplateFull.png"
                alt="Qemplate Logo"
                className="h-8 w-auto"
              />
            </div>
            {/* <button
              onClick={handleBackClick}
              className="flex items-center text-gray-600 hover:text-gray-900 transition-colors group px-3 py-2 rounded-lg hover:bg-gray-100"
            >
              <ArrowLeft
                size={20}
                className="mr-1 group-hover:-translate-x-1 transition-transform"
              />
              <span className="font-medium">Back</span>
            </button> */}
          </div>
        </div>
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="bg-white p-8 sm:p-12 rounded-2xl shadow-lg border border-gray-200">
          <h1 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-6 border-b pb-4">
            Terms of Service
          </h1>
          <p className="text-sm text-gray-500 mb-8">
            Last Updated: {new Date().toLocaleDateString()}
          </p>

          <div className="space-y-8 text-gray-700 leading-relaxed">
            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-3">
                1. Acceptance of Terms
              </h2>
              <p>
                By accessing and using Qemplate (the "Service"), you accept and
                agree to be bound by the terms and provision of this agreement.
                If you do not agree to abide by these terms, please do not use
                this service.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-3">
                2. User Accounts
              </h2>
              <p>
                To use certain features of the Service, you must register for an
                account. You must provide accurate and complete information and
                keep your account information updated. You are responsible for
                the security of your account and passwords.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-3">
                3. Subscriptions & Payments
              </h2>
              <p>
                Some parts of the Service are billed on a subscription basis.
                You will be billed in advance on a recurring and periodic basis.
                All payments are handled by our third-party payment processor,
                Stripe. You may cancel your subscription at any time through
                your account settings or the Stripe customer portal.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-3">
                4. Termination
              </h2>
              <p>
                We may terminate or suspend your account immediately, without
                prior notice or liability, for any reason whatsoever, including
                without limitation if you breach the Terms.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-3">
                5. Changes to Terms
              </h2>
              <p>
                We reserve the right, at our sole discretion, to modify or
                replace these Terms at any time. We will provide notice of
                changes by posting the updated terms on this page.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-3">
                6. Contact Us
              </h2>
              <p>
                If you have any questions about these Terms, please contact us
                at aaron@qemplate.com.
              </p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsOfServicePage;
